import { render, staticRenderFns } from "./AfficheIndex.vue?vue&type=template&id=6f252a60&scoped=true&"
import script from "./AfficheIndex.vue?vue&type=script&lang=js&"
export * from "./AfficheIndex.vue?vue&type=script&lang=js&"
import style0 from "./AfficheIndex.vue?vue&type=style&index=0&id=6f252a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f252a60",
  null
  
)

export default component.exports